import { render, staticRenderFns } from "./EmbeddedAppsDisplay.vue?vue&type=template&id=c360ef4e&scoped=true"
import script from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppsDisplay.vue?vue&type=style&index=0&id=c360ef4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c360ef4e",
  null
  
)

export default component.exports